import React from 'react';
import styled from 'styled-components';

const ButtonSecondaryStyled = styled.button`
    padding: 8px 16px !important;
    background-color: #FF5F391A;
    color: #FF5F39;
    border: none;
    border-radius: 28px;
    cursor: pointer;
    min-height: 35px !important;
    font-size: 12px !important;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1.2;
    transition: all 0.3s ease;
    flex-shrink: 0;
    box-sizing: border-box;

    &:hover {
        background-color: #FF5F39;
        color: white;
    }
    &:focus {
        outline: none;
    }
`;

const ButtonSecondary = ({ onClick, children, className = '', type = 'button', style }) => {
    return (
        <ButtonSecondaryStyled
            className={className}
            onClick={onClick}
            type={type}
            style={style}
        >
            {children}
        </ButtonSecondaryStyled>
    );
};

export default ButtonSecondary;
